<template>
  <div>
    <radio-list
      :name="'status-filter'"
      @input="filterSet"
      :items="rubrics"
      :value="params.id"
    />

    <list
      v-if="rubrics.length"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :params="params"
      :fields="fields"
      :searchDisable="false"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>

<script>
import List from "../List";

import { mapState, mapMutations } from "vuex";

import RadioList from "../Filters/RadioList";

export default {
  name: "groups",
  components: {
    List,
    RadioList,
  },
  created() {
    this.getRubrics();
  },
  methods: {
    getRubrics() {
      this.$http
        .get(`pages/rubrics`)
        .then((response) => {
          this.rubrics = response.data;
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },
    filterSet(val) {
      //console.log(val);
      this.params.id = val;
      this.params.updatedAt = Date.now();
    },
    changeFunction(val) {},
  },
  data() {
    return {
      /**START ADD ITEM */
      rubrics: [],
      val: [],
      params: {
        id: 1,
      },
      modalCreate: "page",
      fields: [
        {
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },

        {
          key: "is_dynamic",
          label: "Динамическая",
          type: "checkbox", //textarea, field, checkbox
        },
        {
          key: "slug",

          label: "Ссылка",
          type: "field",
          textType: "text",
        },
        {
          label: "Рубрики",
          key: "rubric",
          type: "selects",
          selectKey: "title",
          modal: "rubric",
        },
      ],
      /** APIs */
      removeLink: "pages/delete",
      cardLink: "page",
      itemLink: "pages/list",
      setLink: "pages/add",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "title",
          title: "Название",
          checkbox: true,
          control: false,
          full: true,
          align: "left",
          timer: false,
        },
        {
          key: "is_active",
          title: "Активный",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "is_dynamic",
          title: "Динамичная страница",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "slug",
          title: "Внутреняя ссылка",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "created_at",
          title: "Создан",
          checkbox: false,
          control: false,
          full: true,
          align: "right",
          object: "",
        },
        {
          remove: true,
          detail: true,
        },
      ],
      value: null,
    };
  },
};
</script>
<style>
</style>
